import React, { PureComponent } from 'react';
import { Col, Row } from 'reactstrap';
import SmallChart from '../chart/SmallChart';

export default class MonetizationCharts extends PureComponent {
  render() {
    const {
      REVENUE,
      REVENUE_TREND,
      REVENUE_TOTAL,
      CTR,
      CTR_TREND,
      CTR_TOTAL,
      CPM,
      CPM_TREND,
      CPM_TOTAL,
      CLICKS,
      CLICKS_TREND,
      CLICKS_TOTAL,
      IMPRESSIONS,
      IMPRESSIONS_TREND,
      IMPRESSIONS_TOTAL
    } = this.props;
    const blueColor = '#4CE1B6';
    return (
      <div className="dashboard-container content-container monetization">
        <div className="dashboard-title">Monetization</div>
        <Row>
          <Col>
            <SmallChart
              fill={blueColor}
              stroke={blueColor}
              data={REVENUE}
              trend={REVENUE_TREND}
              total={REVENUE_TOTAL}
              totalSign="$"
              title="Revenues"
              className="with-border-radius"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6">
            <SmallChart
              fill={blueColor}
              stroke={blueColor}
              data={CLICKS}
              trend={CLICKS_TREND}
              total={CLICKS_TOTAL}
              title="Clicks"
            />
          </Col>
          <Col sm="6">
            <SmallChart
              fill={blueColor}
              stroke={blueColor}
              data={IMPRESSIONS}
              trend={IMPRESSIONS_TREND}
              total={IMPRESSIONS_TOTAL}
              title="Impressions"
            />
          </Col>
        </Row>
        <Row>
          <Col sm="6">
            <SmallChart
              type="bar"
              fill={blueColor}
              data={CPM}
              trend={CPM_TREND}
              total={CPM_TOTAL}
              totalSign="$"
              title="CPM"
            />
          </Col>
          <Col sm="6">
            <SmallChart
              type="bar"
              fill={blueColor}
              data={CTR}
              trend={CTR_TREND}
              total={CTR_TOTAL}
              totalSign="%"
              title="CTR"
            />
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/MonetizationCharts.js